import { StorageSoftwareVersion } from '../types'

/**
 * Check if software version is of the format 'ProductType_Year_Release'
 * where:
 *  - ProductType: Alphanumeric
 *  - Year: 4-digit year
 *  - Release: Between 1 and 3 digits
 */
const isSoftwareVersionInValidFormat = (version: string): boolean => {
  const versionPattern = /^[A-Za-z0-9]+_\d{4}_\d{1,3}$/
  return versionPattern.test(version)
}

/* Normalize the release to 3 digits so 4 -> 400, 40 -> 400, 04 -> 040, 042 -> 042 */
export const normalizeReleaseNumber = (release: string): number => {
  return parseInt(release.length === 1 ? release + '00' : release.length === 2 ? release + '0' : release, 10)
}

/**
 * Check if the target version is greater than the reference version.
 * Version format: ProductType_Year_Release
 * Release can be 1, 2 or 3 digits (e.g.,X_2024_4, X_2024_04 or X_2022_042).
 * Software Release: https://docs.e3dc.com/display/ENT/Software+Releases
 */
export const isVersionGreaterThanOrEqualTo = (targetVersion: string, referenceVersion = StorageSoftwareVersion.X_2024_04): boolean => {
  if (!isSoftwareVersionInValidFormat(targetVersion) || !isSoftwareVersionInValidFormat(referenceVersion)) {
    throw new Error('Invalid software version format')
  }

  const [, referenceYear, referenceRelease] = referenceVersion.split('_')
  const [, targetYear, targetRelease] = targetVersion.split('_')

  const referenceYearNumber = parseInt(referenceYear, 10)
  const targetYearNumber = parseInt(targetYear, 10)

  /* Compare years first */
  if (targetYearNumber > referenceYearNumber) return true

  const referenceReleaseNumber = normalizeReleaseNumber(referenceRelease)
  const targetReleaseNumber = normalizeReleaseNumber(targetRelease)

  if (targetYearNumber === referenceYearNumber && targetReleaseNumber >= referenceReleaseNumber) return true

  return false
}
